import { createClient } from '@supabase/supabase-js';
import { validateEnvironment, isDevelopment } from './env';

// Validate environment variables at module load
const env = validateEnvironment();

const supabaseUrl = env.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY;

if (isDevelopment() && (!supabaseUrl || !supabaseAnonKey)) {
  console.warn('Supabase credentials not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env');
}

const REMEMBER_ME_KEY = 'erh_remember_me';

const getRememberMe = () => {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem(REMEMBER_ME_KEY) !== 'false';
};

const authStorage = typeof window === 'undefined'
  ? undefined
  : {
      getItem: (key: string) => {
        return getRememberMe() ? localStorage.getItem(key) : sessionStorage.getItem(key);
      },
      setItem: (key: string, value: string) => {
        if (getRememberMe()) {
          localStorage.setItem(key, value);
        } else {
          sessionStorage.setItem(key, value);
        }
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      },
    };

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      storage: authStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
